module.exports = __webpack_public_path__ + "static/img/transforma-tu-aventura-1.0aaf934.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/transforma-tu-aventura-1.jpg
// module id = 5As8
// module chunks = 1